import type { QueryClient } from "@tanstack/react-query";
import { createOpenApiConfiguration } from "@/lib/utils";
import { SeasonsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";

export async function prefetchSeasons(queryClient: QueryClient) {
  // Create API instance without authentication for public access
  const service = new SeasonsApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Seasons],
    queryFn: () => service.apiSeasonsScrollGet({ page: 1, pageSize: 1000 }),
  });

  return queryClient;
}
